import React, { useState } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import { Button, Modal } from "react-bootstrap";

import { SelectInput } from '../SelectInput';
import { TextInput } from '../TextInput';
import { CheckboxInput } from '../CheckboxInput';
import { BLEService } from '../../services';
import BLEScanModal from "../../helpers/thermoworks_node";

const validate = (values => {
    let errors = {};

    if (!values.deviceType) {
        errors.deviceType = i18next.t('messages.please-select-device-type');
        return errors;
    }

    if (values.deviceType.deviceType.deviceSerialNumberType.token === 'lora') {
        if (!values.name) {
            errors.name = i18next.t('messages.please-enter-name');
        }

        if (/\s/g.test(values.name)) {
            errors.name = i18next.t('messages.name-can-not-have-space');
        }

        if (!values.description) {
            errors.description = i18next.t('messages.please-enter-description');
        }

        if (!values.hardwareSerialNumber) {
            errors.hardwareSerialNumber = i18next.t('messages.please-enter-eui');
        } else if (!/^[0-9|a-f|A-F]{16}$/.test(values.hardwareSerialNumber)) {
            errors.hardwareSerialNumber = i18next.t('messages.please-enter-valid-eui');
        }
    } else if (values.deviceType.deviceType.deviceSerialNumberType.token === 'zigbee' || 
               values.deviceType.deviceType.deviceSerialNumberType.token === 'ethernet' || 
               values.deviceType.deviceType.deviceSerialNumberType.token === 'ble' || 
               values.deviceType.deviceType.deviceSerialNumberType.token === 'generated') { 
        
        if (!values.hardwareSerialNumber || values.hardwareSerialNumber === '') {
            errors.hardwareSerialNumber = i18next.t('messages.please-enter-hardware-serial-number');
        }

    } else if (values.deviceType.deviceType.deviceSerialNumberType.token === 'sim') { 
        
        if (!values.hardwareSerialNumber || values.hardwareSerialNumber === '') {
            errors.hardwareSerialNumber = i18next.t('messages.please-enter-sim');
        }

    } else {
        console.error("Unsupported device data type. type=" + values.deviceType.deviceType.deviceSerialNumberType.token)
        errors.unsupported = "Unsupported device data type."
    }

    if (values.deviceType.deviceType.requiresController) {
        if (!values.controllerOpSenseSerialNumber) {
            errors.controllerOpSenseSerialNumber = i18next.t('messages.please-enter-controller-serial-number');
        } 

        if (!values.controllerCommunicationType) {
            errors.controllerCommunicationType = i18next.t('messages.please-select-a-communication-type');
        } else {
            if (values.controllerCommunicationType.controllerCommunicationType === 'mb_rtu') {
                if (!values.modbusRTUUnitId) {
                    errors.modbusRTUUnitId = i18next.t('messages.modbus-rtu-unit-id-required');
                }
            } else if (values.controllerCommunicationType.controllerCommunicationType === 'mb_tcp') {
                if (!values.modbusTCPIP) {
                    errors.modbusTCPIP = i18next.t('messages.modbus-tcp-ip-address-required');
                }
                if (!values.modbusTCPPort) {
                    errors.modbusTCPPort = i18next.t('messages.modbus-tcp-port-required');
                }
            } else {
                errors.controllerCommunicationType = i18next.t('messages.please-select-a-valid-communication-type');
            }
        }
    }

    return errors;
});

class DeviceRegistrationForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedControllerCommunicationType: null
        };
    }

    onBLEComplete(deviceId) {
        if (deviceId) {
            console.log(`Registering device ${deviceId}`);

            this.props.change("hardwareSerialNumber", deviceId);
            this.form.dispatchEvent(new Event("submit"));
        }
    }

    render() {
        if (this.props.deviceTypeOptions) {            
            return (
                <div>
                    <form onSubmit={this.props.handleSubmit} ref={ (ref) => { this.form = ref; } }>
                        <div style={{padding: '10px 0px'}}>
                            <label>{i18next.t('form-labels.device-type')}</label>
                            <Field
                                name="deviceType"
                                options={this.props.deviceTypeOptions}
                                component={SelectInput}
                                onChange={(option) => this.setState({selectedDeviceType: option.deviceType})}
                            />
                        </div>
                        { 
                            this.state.selectedDeviceType && this.state.selectedDeviceType.deviceSerialNumberType.token === "lora" && 
                                <LoRaDeviceTypeFormSection selectedDeviceType={this.state.selectedDeviceType} /> 
                        }
                        { 
                            this.state.selectedDeviceType && 
                            (this.state.selectedDeviceType.deviceSerialNumberType.token === "zigbee" || this.state.selectedDeviceType.deviceSerialNumberType.token === "ethernet" || this.state.selectedDeviceType.deviceSerialNumberType.token === "wifi" || this.state.selectedDeviceType.deviceSerialNumberType.token === "ble") && 
                                <ZigbeeDeviceTypeFormSection /> 
                        }
                        { 
                            this.state.selectedDeviceType && 
                            (this.state.selectedDeviceType.deviceSerialNumberType.token === "sim") && 
                                <SIMDeviceTypeFormSection /> 
                        }
                        { 
                            this.state.selectedDeviceType && 
                            (this.state.selectedDeviceType.deviceSerialNumberType.token === "generated") && 
                                <GeneratedDeviceTypeFormSection readonly={this.state.selectedDeviceType.serialNumberScanType === "ble"} /> 
                        }
                        { 
                            this.state.selectedDeviceType && 
                            (this.state.selectedDeviceType.deviceSerialNumberType.token === "cpu") && 
                                <CPUDeviceTypeFormSection /> 
                        }

                        {
                            this.state.selectedDeviceType &&
                            this.state.selectedDeviceType.serialNumberScanType === "ble" &&
                                <BLEScanFormSection onComplete={this.onBLEComplete.bind(this)} />
                        }

                        {
                            this.state.selectedDeviceType && this.state.selectedDeviceType.requiresController === true &&
                                <ControllerAndSubAddressFormSection 
                                    availableControllers={this.props.availableControllers}
                                    selectedDeviceType={this.state.selectedDeviceType}
                                    selectedControllerCommunicationType={this.state.selectedControllerCommunicationType}
                                    onControllerCommunicationTypeSelection={(option) => this.setState({selectedControllerCommunicationType: option.controllerCommunicationType})}
                                />
                        }
                        <hr />
                        <ul className="list-inline clearfix">
                            <li><button type="submit" className="btn btn-primary btn-block">{ i18next.t('form-labels.save') }</button></li>
                            <li><Link to={ this.props.backLinkWithParams ? this.props.backLinkWithParams.link : `/config/devices`}><button className="btn btn-default">{ i18next.t('form-labels.cancel') }</button></Link></li>
                        </ul>
                    </form>
                </div>
            );
        } else {
            return (
                <div className="loader">{i18next.t('loading')}</div>
            )
        }
    }
}

const LoRaDeviceTypeFormSection = (props) => {
    return (
        <div>
            <div>
                <Field 
                    name="name"
                    label={i18next.t('form-labels.name')}
                    type="text"
                    component={TextInput}
                />
            </div>
            <div>
                <Field 
                    name="description"
                    label={i18next.t('form-labels.description')}
                    type="text"
                    component={TextInput}
                />
            </div>
            <div>
                <Field
                    name="hardwareSerialNumber"
                    label={i18next.t('form-labels.eui')}
                    type="text"
                    component={TextInput}
                />
            </div>            
        </div>
    );
}

const ZigbeeDeviceTypeFormSection = (props) => {
    return (
        <div>
            <div>
                <Field 
                    name="hardwareSerialNumber"
                    label={i18next.t('form-labels.hardware-serial-number')}
                    type="text"
                    component={TextInput}
                />
            </div>            
        </div>
    );
}


const SIMDeviceTypeFormSection = (props) => {
    return (
        <div>
            <div>
                <Field 
                    name="hardwareSerialNumber"
                    label={i18next.t('form-labels.sim-number')}
                    type="text"
                    component={TextInput}
                />
            </div>            
        </div>
    );
}

const GeneratedDeviceTypeFormSection = ({readonly}) => {
    return (
        <div>
            <div>
                <Field name="hardwareSerialNumber" label={i18next.t("form-labels.device-serial-number")} type="text" component={TextInput} readOnly={readonly} />
            </div>
        </div>
    );
};

const CPUDeviceTypeFormSection = (props) => {
    return (
        <div>
            <div>
                <Field name="hardwareSerialNumber" label={i18next.t("form-labels.device-serial-number")} type="text" component={TextInput} />
            </div>
        </div>
    );
};

const BLEScanFormSection = ({onComplete}) => {
    const [showScanModal, setShowScanModal] = useState(false);

    return (
        <div>
            {
                BLEService.canSupportBLECalls() ?
                <div>
                    <ul className="list-inline clearfix">
                        <li><Button onClick={() => setShowScanModal(true)} className="btn btn-primary btn-block">Configure Device</Button></li>
                    </ul>                

                    <BLEScanModal showScanModal={showScanModal} onComplete={(deviceId) => { setShowScanModal(false); onComplete(deviceId); }}/>
                </div>
                :
                <div>
                    This device requires browser support for Web Bluetooth. The browser you are using does not support Web Bluetooth.
                </div>
            }
        </div>
    );
};

const ControllerAndSubAddressFormSection = ({selectedDeviceType, selectedControllerCommunicationType, availableControllers, onControllerCommunicationTypeSelection}) => {
    const controllerCommunicationTypeOptions = selectedDeviceType.controllerCommunicationTypes.map(controllerCommunicationType => {
        var name = "Unknown";
        if (controllerCommunicationType == "mb_rtu") {
            name = "Modbus RTU";
        } else if (controllerCommunicationType == "mb_tcp") {
            name = "Modbus TCP";
        }
        return {value: controllerCommunicationType, label: name, controllerCommunicationType: controllerCommunicationType};
    });

    const controllerOpSenseSerialNumberOptions = availableControllers.map(availableController => 
        ({value: availableController.serialNumber, label: availableController.displayName, controller: availableController})
    );

    return (
        <div>
            <div>
                <label>{i18next.t('form-labels.controller-serial-number')}</label>
                <Field
                    name="controllerOpSenseSerialNumber"
                    options={controllerOpSenseSerialNumberOptions}
                    component={SelectInput}
                />
                <label style={{paddingTop: 10}}>{i18next.t('form-labels.controller-communication-types')}</label>
                <Field
                    name="controllerCommunicationType"
                    options={controllerCommunicationTypeOptions}
                    component={SelectInput}
                    onChange={onControllerCommunicationTypeSelection}
                />
                {
                    (selectedControllerCommunicationType == "mb_rtu" && <ModbusRTUCommunicationTypeForm />) ||
                    (selectedControllerCommunicationType == "mb_tcp" && <ModbusTCPCommunicationTypeForm />)
                }
            </div>
        </div>
    );
};

const ModbusRTUCommunicationTypeForm = () => {
    const [advanced, setAdvanced] = useState(false);

    return (
        <div style={{paddingTop: 10}}>
            <div>
                <Field name="modbusRTUUnitId" label={i18next.t("form-labels.controller-communication-unit-id")} type="text" component={TextInput} />

                <CheckboxInput
                    input={{checked: advanced, onChange: () => {setAdvanced(!advanced)}}}
                    label={ i18next.t('form-labels.advanced') }
                    className="inline"
                    meta={{}}
                />

                {
                    advanced && 
                    <div>
                        <Field name="modbusRTUTimeout" label={i18next.t("form-labels.controller-communication-timeout")} type="text" component={TextInput} />
                        <Field name="modbusRTUSerialConfig" label={i18next.t("form-labels.controller-communication-serial-config")} type="text" component={TextInput} />
                    </div>
                }
            </div>
        </div>
    );
};

const ModbusTCPCommunicationTypeForm = () => {
    const [advanced, setAdvanced] = useState(false);

    return (
        <div style={{paddingTop: 10}}>
            <div>
                <Field name="modbusTCPIP" label={i18next.t("form-labels.controller-communication-tcp-ip")} type="text" component={TextInput} />
                <Field name="modbusTCPPort" label={i18next.t("form-labels.controller-communication-tcp-port")} type="text" component={TextInput} />

                <CheckboxInput
                    input={{checked: advanced, onChange: () => {setAdvanced(!advanced)}}}
                    label={ i18next.t('form-labels.advanced') }
                    className="inline"
                    meta={{}}
                />

                {
                    advanced && 
                    <div>
                        <Field name="modbusTCPTimeout" label={i18next.t("form-labels.controller-communication-timeout")} type="text" component={TextInput} />
                    </div>
                }
            </div>
        </div>
    );
};


export default reduxForm({ form: 'DeviceRegistrationForm', validate })(DeviceRegistrationForm);